import { useState } from "react";
import FilterChips from "./Chips";
const categories = [
  "shrub",
  "tree",
  "groundcover",
  "herb",
  "grass",
  "climber",
  "fern",
  "orchid",
  "succulent",
  "aquatic",
  "vine",
  "palm",
  "bulb",
  "cyad",
  "epiphyte",
  "moss",
];
const FilterCategory = ({ value, onChange }) => {
  return (
    <FilterChips
      title={"Category"}
      value={value}
      options={categories}
      onChange={onChange}
    />
  );
};

export default FilterCategory;
